import { usePermissions } from "../../../hooks/usePermissions";
import { ClientProps } from "../../../interfaces/interfaces";
import { PumpModuleAdmin } from "../pump/PumpModuleAdmin";

interface Props {
  clientMode?: boolean;
  assignedClientOptions?: ClientProps[];
  assignedClientId?: number | null;
  onAssignedClientChange?: (clientId: number | null) => void;
}

export const CoiPumpAdmin = (props: Props) => {
  const { canManageCoiPump } = usePermissions();
  return (
    <PumpModuleAdmin
      apiPrefix="coi-pump"
      title="Pump COI"
      canManage={canManageCoiPump}
      {...props}
    />
  );
};
